import React from 'react';
import ReactLoading from 'react-loading';

const Loader = () => {
    return (
        <div className="loader-background" onClick={e => e.stopPropagation()}>
            <div className="wobo-loader">
                <ReactLoading type={'spinningBubbles'}
                    color={'#52bad5'} height={'50px'} width={'50px'} />
            </div>
        </div>
    )
    
}

export default Loader;